<div class="loader-main">
    <div class="loader-overlay">
        <div class="wandering-cubes">
            <div class="cube loader-cube1"></div>
            <div class="cube loader-cube2"></div>
            <div class="cube loader-cube3"></div>
            <div class="cube loader-cube4"></div>
        </div>
    </div>
</div>